<template>
  <article>
    <Search title="Artwork Finder" />
  </article>
</template>

<script setup lang="ts">
import Search from '@/components/Search.vue';
</script>
